export default __webpack_public_path__ + "static/media/highest-bid-all-editions.c1af1a4e.svg";